// import "babel-polyfill";
// import Es6Promise from "es6-promise";
// Es6Promise.polyfill();
import "babel-polyfill";
import Es6Promise from "es6-promise";
require("es6-promise").polyfill();
Es6Promise.polyfill();

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store';
import "./assets/js/flexible.js";
import "./assets/css/common.scss";
// import gallery from 'img-vuer' // 查看放大图片
// import rate from "vue-rate"; // 星星
// Vue.use(rate);
import filterFn from "./utils/filter"; // filter
import mixin from "./utils/mixins"; // mixins
//import 'vant/lib/index.css';

// import VConsole from "vconsole";

// new VConsole();

// import Vant from "vant";
import "vant/lib/index.css";

// Vue.use(Vant);

Vue.config.productionTip = false;

// Vue.mixin(mixin);
// Vue.use(gallery, {
//   preload: true,
//   // isIndexShow:false,
//   useCloseButton: true,
//   swipeThreshold: 150 // default 100 ,new in 0.12.0
// });

// filterFn(Vue);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})